import { useRef, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Loader2, ImagePlus, X } from "lucide-react";
import { toast } from "sonner";
import { prepareImage } from "@/lib/prepareImage";

const ASPECT = { video: "aspect-video", portrait: "aspect-[4/5]", square: "aspect-square" };

export default function ImageUploader({ value, onChange, onUploadingChange, testid = "image-uploader", aspect = "video", hint }) {
  const inputRef = useRef();
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    onUploadingChange?.(true);
    try {
      const fd = new FormData();
      fd.append("file", await prepareImage(file));
      const { data } = await api.post("/upload", fd);
      onChange(data.path);
      toast.success("تم رفع الصورة");
    } catch (error) {
      toast.error(error.response?.data?.detail || error.message || "فشل رفع الصورة");
    } finally {
      setUploading(false);
      onUploadingChange?.(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const box = `w-full ${ASPECT[aspect] || ASPECT.video} ${aspect === "portrait" ? "max-w-[260px]" : ""}`;

  return (
    <div>
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" hidden disabled={uploading} onChange={handle} data-testid={`${testid}-input`} />
      {value ? (
        <div className={`relative ${box} rounded-2xl overflow-hidden border border-border`}>
          <img src={fileUrl(value)} alt="preview" className="w-full h-full object-cover" />
          <button type="button" disabled={uploading} data-testid={`${testid}-remove`} onClick={() => onChange("")}
            className="absolute top-2 left-2 w-8 h-8 rounded-full bg-brand/70 text-brand-foreground grid place-items-center hover:bg-brand/90 transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <button type="button" data-testid={`${testid}-btn`} onClick={() => inputRef.current?.click()} disabled={uploading}
          className={`${box} rounded-2xl border-2 border-dashed border-border grid place-items-center text-muted-foreground hover:border-primary hover:text-primary transition-colors bg-muted/30`}>
          {uploading ? <Loader2 className="w-6 h-6 animate-spin" /> : (
            <div className="text-center px-4">
              <ImagePlus className="w-7 h-7 mx-auto" />
              <div className="text-sm mt-2 font-medium">اضغط لرفع صورة</div>
              {hint && <div className="text-[11px] mt-1 opacity-70">{hint}</div>}
            </div>
          )}
        </button>
      )}
    </div>
  );
}
